/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response after requesting an SMS code.
 * @export
 * @interface MncapSendSmsCodeResponseDto
 */
export interface MncapSendSmsCodeResponseDto {
    /**
     * Outcome of the SMS send request.
     * - SENT: SMS dispatched via Brevo
     * - COOLDOWN: a previous code was sent less than 60s ago
     * - MAX_RESENDS_REACHED: max 3 resends per token exceeded, locked for 10 min
     * - INVALID_TOKEN: token does not exist or expired
     * 
     * @type {string}
     * @memberof MncapSendSmsCodeResponseDto
     */
    status: MncapSendSmsCodeResponseDtoStatusEnum;
    /**
     * Seconds left before the borrower may request a new code. Filled when status is COOLDOWN.
     * @type {number}
     * @memberof MncapSendSmsCodeResponseDto
     */
    cooldownSecondsRemaining?: number | null;
    /**
     * Validity of the freshly sent code in seconds (typically 120). Filled when status is SENT.
     * @type {number}
     * @memberof MncapSendSmsCodeResponseDto
     */
    expiresInSeconds?: number | null;
}


/**
 * @export
 */
export const MncapSendSmsCodeResponseDtoStatusEnum = {
    Sent: 'SENT',
    Cooldown: 'COOLDOWN',
    MaxResendsReached: 'MAX_RESENDS_REACHED',
    InvalidToken: 'INVALID_TOKEN'
} as const;
export type MncapSendSmsCodeResponseDtoStatusEnum = typeof MncapSendSmsCodeResponseDtoStatusEnum[keyof typeof MncapSendSmsCodeResponseDtoStatusEnum];


/**
 * Check if a given object implements the MncapSendSmsCodeResponseDto interface.
 */
export function instanceOfMncapSendSmsCodeResponseDto(value: object): value is MncapSendSmsCodeResponseDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function MncapSendSmsCodeResponseDtoFromJSON(json: any): MncapSendSmsCodeResponseDto {
    return MncapSendSmsCodeResponseDtoFromJSONTyped(json, false);
}

export function MncapSendSmsCodeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MncapSendSmsCodeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'cooldownSecondsRemaining': json['cooldownSecondsRemaining'] == null ? undefined : json['cooldownSecondsRemaining'],
        'expiresInSeconds': json['expiresInSeconds'] == null ? undefined : json['expiresInSeconds'],
    };
}

export function MncapSendSmsCodeResponseDtoToJSON(json: any): MncapSendSmsCodeResponseDto {
    return MncapSendSmsCodeResponseDtoToJSONTyped(json, false);
}

export function MncapSendSmsCodeResponseDtoToJSONTyped(value?: MncapSendSmsCodeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'cooldownSecondsRemaining': value['cooldownSecondsRemaining'],
        'expiresInSeconds': value['expiresInSeconds'],
    };
}

